import React from 'react';
import PropTypes from 'prop-types';

const IconBackground = ({children}) => (
  <span className="RoyalBuildYourOrder__body_disclosures_disclosure_icon">{children}</span>
);

IconBackground.propTypes = {
  children: PropTypes.node,
};

export default IconBackground;
